import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function RADPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Results and Discussions</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
<ol>
<li>
<p><em><strong>3.1 Estimation of Spatiotemporal Changes in LU and Landscape Configuration</strong></em></p>
<p>LU changes have been analyzed using temporal remote sensing data, revealing the level of degradation from 1989 to 2019 (Table 2). LU changes in the Gadag district were analyzed under various LU classes such as agriculture, built-up area, dry deciduous forests, water, horticulture, scrub open, and hills for each decade. Table 3 and Figure 5 present the spatial LU transition from 1989 to 2019 under each class. Forests occupy approximately seven percent of the total geographical area. The LU analysis depicted a decrease in forest cover by 509 ha from 1989 to 2019 due to the encroachment of forest land and the transition to agriculture in the peripheral area. Area under cotton cultivation has increased with the setting up of industries in the district. An increase in urbanization subsequently led to the conversion of agricultural land to built-up, as observed from 2009 to 2019. The transition from agriculture to built-up cover is noticed in the sub-urban regions of Gadag due to new residential layouts and small-scale industries. The primary causal factors of LU changes are the implementation of infrastructure projects like the road connecting Bagalkot and Gadag, the development of an agri-logistic hub, large-scale industries like the Gadag Co-operative Textile Mill, the Farmer&rsquo;s Co-operative Spinning Mills, oil mills, sugar factories, a 700MW gas-based power project, etc. <span>The overall accuracy of the classification was 87.01% (1989), 87.75% (1999), 94.11% (2009), 91.88% (2019) with kappa value as 0.87, 0.88, 0.91 and 0.88, respectively.</span></p>
<p><strong>Table 2</strong> Spatiotemporal LU dynamics.</p>
<center>
<table>
<tbody>
<tr>
<td style={styles.cell}>
<p><strong>Year</strong></p>
</td>
<td colSpan={2} style={styles.cell}>
<p><strong>1989</strong></p>
</td>
<td colSpan={2} style={styles.cell}>
<p><strong>1999</strong></p>
</td>
<td colSpan={2} style={styles.cell}>
<p><strong>2009</strong></p>
</td>
<td colSpan={2} style={styles.cell}>
<p><strong>2019</strong></p>
</td>

</tr>
<tr>
<td style={styles.cell}>
<p><strong>Category</strong></p>
</td>
<td style={styles.cell}>
<p><strong>km</strong><sup><strong>2</strong></sup></p>
</td>
<td style={styles.cell}>
<p><strong>%</strong></p>
</td>
<td style={styles.cell}>
<p><strong>km</strong><sup><strong>2</strong></sup></p>
</td>
<td style={styles.cell}>
<p><strong>%</strong></p>
</td>
<td style={styles.cell}>
<p><strong>km</strong><sup><strong>2</strong></sup></p>
</td>
<td style={styles.cell}>
<p><strong>%</strong></p>
</td>
<td style={styles.cell}>
<p><strong>km</strong><sup><strong>2</strong></sup></p>
</td>
<td style={styles.cell}>
<p><strong>%</strong></p>
</td>
</tr>
</tbody>
<tbody>
<tr>
<td style={styles.cell}>
<p>Agriculture</p>
</td>
<td style={styles.cell}>
<p>4320.7</p>
</td>
<td style={styles.cell}>
<p>92.9</p>
</td>
<td style={styles.cell}>
<p>4323.56</p>
</td>
<td style={styles.cell}>
<p>92.95</p>
</td>
<td style={styles.cell}>
<p>4318.98</p>
</td>
<td style={styles.cell}>
<p>92.86</p>
</td>
<td style={styles.cell}>
<p>4265.91</p>
</td>
<td style={styles.cell}>
<p>91.73</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Built-up</p>
</td>
<td style={styles.cell}>
<p>2.01</p>
</td>
<td style={styles.cell}>
<p>0.04</p>
</td>
<td style={styles.cell}>
<p>4.89</p>
</td>
<td style={styles.cell}>
<p>0.11</p>
</td>
<td style={styles.cell}>
<p>9.9</p>
</td>
<td style={styles.cell}>
<p>0.21</p>
</td>
<td style={styles.cell}>
<p>64.53</p>
</td>
<td style={styles.cell}>
<p>1.39</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Dry deciduous</p>
</td>
<td style={styles.cell}>
<p>296.57</p>
</td>
<td style={styles.cell}>
<p>6.38</p>
</td>
<td style={styles.cell}>
<p>290.29</p>
</td>
<td style={styles.cell}>
<p>6.24</p>
</td>
<td style={styles.cell}>
<p>291.17</p>
</td>
<td style={styles.cell}>
<p>6.26</p>
</td>
<td style={styles.cell}>
<p>280.75</p>
</td>
<td style={styles.cell}>
<p>6.04</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Water</p>
</td>
<td style={styles.cell}>
<p>22.28</p>
</td>
<td style={styles.cell}>
<p>0.48</p>
</td>
<td style={styles.cell}>
<p>23.61</p>
</td>
<td style={styles.cell}>
<p>0.51</p>
</td>
<td style={styles.cell}>
<p>22.28</p>
</td>
<td style={styles.cell}>
<p>0.48</p>
</td>
<td style={styles.cell}>
<p>21.71</p>
</td>
<td style={styles.cell}>
<p>0.47</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Horticulture</p>
</td>
<td style={styles.cell}>
<p>0.05</p>
</td>
<td style={styles.cell}>
<p>0.01</p>
</td>
<td style={styles.cell}>
<p>0.07</p>
</td>
<td style={styles.cell}>
<p>0.01</p>
</td>
<td style={styles.cell}>
<p>0.07</p>
</td>
<td style={styles.cell}>
<p>0.01</p>
</td>
<td style={styles.cell}>
<p>1.29</p>
</td>
<td style={styles.cell}>
<p>0.03</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Scrub</p>
</td>
<td style={styles.cell}>
<p>3.77</p>
</td>
<td style={styles.cell}>
<p>0.08</p>
</td>
<td style={styles.cell}>
<p>3.41</p>
</td>
<td style={styles.cell}>
<p>0.07</p>
</td>
<td style={styles.cell}>
<p>6.46</p>
</td>
<td style={styles.cell}>
<p>0.14</p>
</td>
<td style={styles.cell}>
<p>14.50</p>
</td>
<td style={styles.cell}>
<p>0.31</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Open area</p>
</td>
<td style={styles.cell}>
<p>3.18</p>
</td>
<td style={styles.cell}>
<p>0.07</p>
</td>
<td style={styles.cell}>
<p>3.16</p>
</td>
<td style={styles.cell}>
<p>0.07</p>
</td>
<td style={styles.cell}>
<p>0.17</p>
</td>
<td style={styles.cell}>
<p>0</p>
</td>
<td style={styles.cell}>
<p>0.00</p>
</td>
<td style={styles.cell}>
<p>0.00</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Hill</p>
</td>
<td style={styles.cell}>
<p>1.81</p>
</td>
<td style={styles.cell}>
<p>0.04</p>
</td>
<td style={styles.cell}>
<p>1.8</p>
</td>
<td style={styles.cell}>
<p>0.04</p>
</td>
<td style={styles.cell}>
<p>1.75</p>
</td>
<td style={styles.cell}>
<p>0.04</p>
</td>
<td style={styles.cell}>
<p>1.71</p>
</td>
<td style={styles.cell}>
<p>0.04</p>
</td>
</tr>
</tbody>
</table>
</center>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Table 3</strong> LU transition from 1989 to 2019.</p>
<center>
<table>
<tbody>
<tr>
<td style={styles.cell}>
<p><span><strong>2005</strong></span></p>
</td>
<td colSpan={9} style={styles.cell}>
<p style={{textAlign:"center"}}><span><strong>2019</strong></span></p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p><span><strong>LU Category (km</strong></span><sup><span><strong>2</strong></span></sup><span><strong>)</strong></span></p>
</td>
<td style={styles.cell}>
<p><span><strong>Agriculture</strong></span></p>
</td>
<td style={styles.cell}>
<p><span><strong>Built-up</strong></span></p>
</td>
<td style={styles.cell}>
<p><span><strong>Dry deciduous</strong></span></p>
</td>
<td style={styles.cell}>
<p><span><strong>Water</strong></span></p>
</td>
<td style={styles.cell}>
<p><span><strong>Horticulture</strong></span></p>
</td>
<td style={styles.cell}>
<p><span><strong>Scrub</strong></span></p>
</td>
<td style={styles.cell}>
<p><span><strong>Open area</strong></span></p>
</td>
<td style={styles.cell}>
<p><span><strong>Hill</strong></span></p>
</td>
<td style={styles.cell}>
<p><span><strong>Total</strong></span></p>
</td>
</tr>
</tbody>
<tbody>
<tr>
<td style={styles.cell}>
<p><span>Agriculture</span></p>
</td>
<td style={styles.cell}>
<p><span>4263.210</span></p>
</td>
<td style={styles.cell}>
<p><span>53.315</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>1.168</span></p>
</td>
<td style={styles.cell}>
<p><span>3.047</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>4320.74</span></p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p><span>Built-up</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>0.378</span></p>
</td>
<td style={styles.cell}>
<p><span>0.083</span></p>
</td>
<td style={styles.cell}>
<p><span>0.001</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>0.003</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>1.545</span></p>
</td>
<td style={styles.cell}>
<p><span>2.01</span></p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p><span>Dry deciduous</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>10.839</span></p>
</td>
<td style={styles.cell}>
<p><span>277.037</span></p>
</td>
<td style={styles.cell}>
<p><span>1.507</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>7.185</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>0.001</span></p>
</td>
<td style={styles.cell}>
<p><span>296.57</span></p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p><span>Water</span></p>
</td>
<td style={styles.cell}>
<p><span>0.002</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>1.866</span></p>
</td>
<td style={styles.cell}>
<p><span>20.039</span></p>
</td>
<td style={styles.cell}>
<p><span>0.093</span></p>
</td>
<td style={styles.cell}>
<p><span>0.280</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>22.28</span></p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p><span>Horticulture</span></p>
</td>
<td style={styles.cell}>
<p><span>0.011</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>0.004</span></p>
</td>
<td style={styles.cell}>
<p><span>0.033</span></p>
</td>
<td style={styles.cell}>
<p><span>0.001</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>0.05</span></p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p><span>Scrub</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>3.770</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>3.77</span></p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p><span>Open area</span></p>
</td>
<td style={styles.cell}>
<p><span>2.379</span></p>
</td>
<td style={styles.cell}>
<p><span>0.000</span></p>
</td>
<td style={styles.cell}>
<p><span>0.324</span></p>
</td>
<td style={styles.cell}>
<p><span>0.108</span></p>
</td>
<td style={styles.cell}>
<p><span>0.022</span></p>
</td>
<td style={styles.cell}>
<p><span>0.216</span></p>
</td>
<td style={styles.cell}>
<p><span>0.001</span></p>
</td>
<td style={styles.cell}>
<p><span>0.130</span></p>
</td>
<td style={styles.cell}>
<p><span>3.18</span></p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p><span>Hill</span></p>
</td>
<td style={styles.cell}>
<p><span>0.308</span></p>
</td>
<td style={styles.cell}>
<p><span>0.002</span></p>
</td>
<td style={styles.cell}>
<p><span>1.436</span></p>
</td>
<td style={styles.cell}>
<p><span>0.025</span></p>
</td>
<td style={styles.cell}>
<p><span>0.007</span></p>
</td>
<td style={styles.cell}>
<p><span>0.001</span></p>
</td>
<td style={styles.cell}>
<p><span>0.001</span></p>
</td>
<td style={styles.cell}>
<p><span>0.030</span></p>
</td>
<td style={styles.cell}>
<p><span>1.81</span></p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>&nbsp;</p>
</td>
<td style={styles.cell}>
<p><span>4265.91</span></p>
</td>
<td style={styles.cell}>
<p><span>64.53</span></p>
</td>
<td style={styles.cell}>
<p><span>280.75</span></p>
</td>
<td style={styles.cell}>
<p><span>21.71</span></p>
</td>
<td style={styles.cell}>
<p><span>1.29</span></p>
</td>
<td style={styles.cell}>
<p><span>14.50</span></p>
</td>
<td style={styles.cell}>
<p><span>0.00</span></p>
</td>
<td style={styles.cell}>
<p><span>1.71</span></p>
</td>
<td style={styles.cell}>
<p><span>4650.41</span></p>
</td>
</tr>
</tbody>
</table>
</center>
<p style={{textAlign:"center"}}><img width={500} height={500} src="images/fig5.png"/></p>
<p style={{textAlign:"center"}}><strong>Figure 5</strong> LU of Gadag from 1989 to 2019.</p>
<p><a></a> The assessment of spatiotemporal forest fragmentation, i.e., zone of forests prone to degradation, has been achieved through temporal LU information. Table 4 presents the spatial extent of various fragmentation types&mdash;interior, perforated, edge, transitional, patch, and non-forest. Figure 6 presents the spatial patterns of forest fragmentation, showing 4.06% of contiguous interior forests in 2019 as part of the Dharwar craton named Kappata Gudda. Edge forests (0.25%) are located around non-forest areas, roads, rivers, etc., while perforated forests (1.08%) are the forest types formed between the interior and smaller perforations within each forest type (Figure 7). It was evident from the field visit that the cultivation practices at the edges of Mundargi and the implementation of windmill power projects (total power generation of 115.4 MW generation under various schemes) have contributed to the degradation of forests.</p>
<ol>
<li>
<p><strong>Table 4</strong> Temporal changes in forest fragmentation from 1989 to 2019.</p>
<center>
<table>
<tbody>
<tr>
<td style={styles.cell}>
<p><strong>Year</strong></p>
</td>
<td colSpan={2} style={styles.cell}>
<p><strong>1989</strong></p>
</td>
<td colSpan={2} style={styles.cell}>
<p><strong>1999</strong></p>
</td>
<td colSpan={2} style={styles.cell}>
<p><strong>2009</strong></p>
</td>
<td colSpan={2} style={styles.cell}>
<p><strong>2019</strong></p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p><strong>Fragmentation Type</strong></p>
</td>
<td style={styles.cell}>
<p><strong>km</strong><sup><strong>2</strong></sup></p>
</td>
<td style={styles.cell}>
<p><strong>%</strong></p>
</td>
<td style={styles.cell}>
<p><strong>km</strong><sup><strong>2</strong></sup></p>
</td>
<td style={styles.cell}>
<p><strong>%</strong></p>
</td>
<td style={styles.cell}>
<p><strong>km</strong><sup><strong>2</strong></sup></p>
</td>
<td style={styles.cell}>
<p><strong>%</strong></p>
</td>
<td style={styles.cell}>
<p><strong>km</strong><sup><strong>2</strong></sup></p>
</td>
<td style={styles.cell}>
<p><strong>%</strong></p>
</td>
</tr>
</tbody>
<tbody>
<tr>
<td style={styles.cell}>
<p>Non-forest</p>
</td>
<td style={styles.cell}>
<p>4339.6</p>
</td>
<td style={styles.cell}>
<p>93.32</p>
</td>
<td style={styles.cell}>
<p>4346.1</p>
</td>
<td style={styles.cell}>
<p>93.45</p>
</td>
<td style={styles.cell}>
<p>4352.77</p>
</td>
<td style={styles.cell}>
<p>93.59</p>
</td>
<td style={styles.cell}>
<p>4355.77</p>
</td>
<td style={styles.cell}>
<p>93.66</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Patch</p>
</td>
<td style={styles.cell}>
<p>26.5081</p>
</td>
<td style={styles.cell}>
<p>0.57</p>
</td>
<td style={styles.cell}>
<p>24.114</p>
</td>
<td style={styles.cell}>
<p>0.52</p>
</td>
<td style={styles.cell}>
<p>22.6505</p>
</td>
<td style={styles.cell}>
<p>0.49</p>
</td>
<td style={styles.cell}>
<p>21.1664</p>
</td>
<td style={styles.cell}>
<p>0.46</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Transitional</p>
</td>
<td style={styles.cell}>
<p>26.3092</p>
</td>
<td style={styles.cell}>
<p>0.57</p>
</td>
<td style={styles.cell}>
<p>24.623</p>
</td>
<td style={styles.cell}>
<p>0.53</p>
</td>
<td style={styles.cell}>
<p>22.7558</p>
</td>
<td style={styles.cell}>
<p>0.49</p>
</td>
<td style={styles.cell}>
<p>23.1825</p>
</td>
<td style={styles.cell}>
<p>0.5</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Edge</p>
</td>
<td style={styles.cell}>
<p>12.3054</p>
</td>
<td style={styles.cell}>
<p>0.26</p>
</td>
<td style={styles.cell}>
<p>12.163</p>
</td>
<td style={styles.cell}>
<p>0.26</p>
</td>
<td style={styles.cell}>
<p>11.9103</p>
</td>
<td style={styles.cell}>
<p>0.26</p>
</td>
<td style={styles.cell}>
<p>11.634</p>
</td>
<td style={styles.cell}>
<p>0.25</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Perforated</p>
</td>
<td style={styles.cell}>
<p>53.3736</p>
</td>
<td style={styles.cell}>
<p>1.15</p>
</td>
<td style={styles.cell}>
<p>52.055</p>
</td>
<td style={styles.cell}>
<p>1.12</p>
</td>
<td style={styles.cell}>
<p>51.1703</p>
</td>
<td style={styles.cell}>
<p>1.1</p>
</td>
<td style={styles.cell}>
<p>50.1442</p>
</td>
<td style={styles.cell}>
<p>1.08</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Interior</p>
</td>
<td style={styles.cell}>
<p>192.31</p>
</td>
<td style={styles.cell}>
<p>4.14</p>
</td>
<td style={styles.cell}>
<p>191.7</p>
</td>
<td style={styles.cell}>
<p>4.12</p>
</td>
<td style={styles.cell}>
<p>189.523</p>
</td>
<td style={styles.cell}>
<p>4.08</p>
</td>
<td style={styles.cell}>
<p>188.887</p>
</td>
<td style={styles.cell}>
<p>4.06</p>
</td>
</tr>
</tbody>
</table>
</center>
<p style={{textAlign:"center"}}><img width={500} height={500} src="images/fig6.png"/></p>
<p style={{textAlign:"center"}}><strong>Figure 6</strong> Temporal pattern of fragmentation between 1989 and 2019.</p>
<p style={{textAlign:"center"}}><img style={{mixBlendMode:"multiply"}} width={500} height={500} src="images/fig7.png"/></p>
<p style={{textAlign:"center"}}><strong>Figure 7 </strong>Forest fragmentation between 1989 and 2019.</p>
<p>The landscape metrics were assessed to understand the spatial patterns of the LU dynamics of built-up and forest classes across the grids based on the classified LU data of 1989, 1999, 2009, and 2019 (Figure 8 and Figure 9). Four prioritized spatial indices [17] were computed at the landscape level &mdash;class area, Normalized Landscape Shape Index (NLSI), Aggregation Index (AI), and Number of Patches (NP).</p>
<p style={{textAlign:"center"}}><img width={500} height={500} src="images/fig8.png"/></p>
<p style={{textAlign:"center"}}><strong>Figure 8</strong> Spatial pattern analysis of built-up class over a temporal scale.</p>
<p style={{textAlign:"center"}}><img width={500} height={500} src="images/fig9.png"/></p>
<p style={{textAlign:"center"}}><strong>Figure 9</strong> Spatial metrics concerning forest classes for 1989&ndash;2019.</p>
<p>3.1.1 Class Area</p>
<p>The class area comprises the area of the particular class type present in the particular grid, with the maximum area that can be occupied in a single cell being 81 sq km or 8100 hectares. The change in the built-up over time was evident, especially with the Gadag City Municipal Council and the town of Gajendragad experiencing significant urbanization. It is evident that the area under forests has decreased over time, particularly in the Mundargi and Shirahatti side of the Kappata Gudda range and in the Rona taluk of Gajendragad.</p>
<p>3.1.2 Number of Patches (NP)</p>
<p>NP is one of the fragmentation indices where a higher number indicates more fragmentation, while an NP closer to &ldquo;0&rdquo; indicates agglomerated or compact growth. Mundargi, Gajendragad, and Gadag were found to experience considerably higher scattered growth. Loss of forest patches was observed around the Gadag and Shirahatti sides of Kappata Gudda from 1989 to 2019, indicating an increase in fragmentation.</p>
<p>3.1.3 Aggregation Index (AI)</p>
<p>AI is equal to 100 when the patches form a single compacted cluster. On the other hand, the value is equal to 1 when the patches are disaggregated. The AI values were initially observed for built-up areas in some confined patches of Gadag, Gajendragad, and Shirahatti around 1989. There was then a rise in the increase of built-up cover across the district, indicating a compact cluster around Gajendragad and Gadag. The decline of the AI value in the Gadag and Shirahatti regions indicates forest fragmentation.</p>
<p>3.1.4 Normalized Landscape Shape Index (NLSI)</p>
<p>NLSI describes the shape of the landscape. The value 0 indicates the class compactness in a grid, while 1 indicates the most scattered class. Gadag district started experiencing considerable urban sprawl in 1999, evident from the higher NLSI values. The NLSI values declined post-2009 in Gadag, Gajendragad, and Naragund, indicating compacted growth. Similarly, the forest cover around the Mundargi side of Kappata Gudda declined, as evident from the increased shape complexity.</p>
<p><em><strong>3.2 Modeling LU Dynamics </strong></em></p>
<p>The prediction of the likely LU transitions is made through a hybrid fuzzy AHP MCA modeling approach considering 5 LU categories (Table 5)&mdash;natural vegetation (deciduous forest and scrub), monoculture plantations (forest plantations and horticulture), agriculture, built-up, and water. Based on the zone of influence and the growth trend of each agent with respect to built-up and classes of monoculture agriculture, weights were assigned with acceptable consistency, i.e., eigenvalues were generated such that the consistency of the weights &lt; 0.1 for each agent (Table 6). Transitions from 2009&ndash;to 2019 were estimated and simulated using the LU of 2019, which was compared with the actual LU of 2019 for validation through accuracy assessment. The agreement of simulated LU with the actual LU was evaluated through a set of Kappa indices such as K<sub>no</sub> (0.9), K<sub>location</sub> (0.94), K<sub>standard</sub> (0.89). Based on the consistency, the LU for 2029 was simulated by incorporating the influencing factors and constraints (Figure 10). The results indicated a likely increase of built-up of 4%, with the loss of agriculture and forest cover hindering the availability of natural resources and food. Supporting industrialization policies and water availability would aid as a major catalyst for large-scale LU transitions in the region.</p>
<p><strong>Table 5</strong> LU categories used for simulation and prediction.</p>
<center>
<table>
<tbody>
<tr>
<td style={styles.cell}>
<p><strong>Land Use</strong></p>
</td>
<td style={styles.cell}>
<p><strong>Categories</strong></p>
</td>
</tr>
</tbody>
<tbody>
<tr>
<td style={styles.cell}>
<p>Forest</p>
</td>
<td style={styles.cell}>
<p>Dry Deciduous, Scrub</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Monoculture</p>
</td>
<td style={styles.cell}>
<p>Forest plantation, Horticulture.</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Agriculture</p>
</td>
<td style={styles.cell}>
<p>Agriculture</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Built-up</p>
</td>
<td style={styles.cell}>
<p>Built-up</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Water</p>
</td>
<td style={styles.cell}>
<p>Water</p>
</td>
</tr>
</tbody>
</table>
</center>
<p><strong>Table 6</strong> Function type, range, and the weights assigned across the LU classes.</p>
<center>
<table>
<tbody>
<tr>
<td style={styles.cell}>
<p><strong>Built-up </strong></p>
</td>
<td style={styles.cell}>
<p><strong>Function </strong></p>
</td>
<td style={styles.cell}>
<p><strong>Range (m) </strong></p>
</td>
<td style={styles.cell}>
<p><strong>Weight </strong></p>
</td>
</tr>
</tbody>
<tbody>
<tr>
<td style={styles.cell}>
<p>Road</p>
</td>
<td style={styles.cell}>
<p>J-Shaped Decreasing</p>
</td>
<td style={styles.cell}>
<p>100 &ndash; 2500</p>
</td>
<td style={styles.cell}>
<p>0.2935</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Slope (%)</p>
</td>
<td style={styles.cell}>
<p>Linear Decreasing</p>
</td>
<td style={styles.cell}>
<p>1&ndash;30</p>
</td>
<td style={styles.cell}>
<p>Constraint</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Industry</p>
</td>
<td style={styles.cell}>
<p>Sigmoidal Decreasing</p>
</td>
<td style={styles.cell}>
<p>2000 &ndash; 6000</p>
</td>
<td style={styles.cell}>
<p>0.0827</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Education</p>
</td>
<td style={styles.cell}>
<p>Sigmoidal Decreasing</p>
</td>
<td style={styles.cell}>
<p>500&ndash;4500</p>
</td>
<td style={styles.cell}>
<p>0.1336</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>City center</p>
</td>
<td style={styles.cell}>
<p>Sigmoidal Decreasing</p>
</td>
<td style={styles.cell}>
<p>1000 &ndash; 20000</p>
</td>
<td style={styles.cell}>
<p>0.3022</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Socio-culture</p>
</td>
<td style={styles.cell}>
<p>Sigmoidal Decreasing</p>
</td>
<td style={styles.cell}>
<p>1000&ndash;4000</p>
</td>
<td style={styles.cell}>
<p>0.0329</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Bus &amp; Railway Station</p>
</td>
<td style={styles.cell}>
<p>Symmetric</p>
</td>
<td style={styles.cell}>
<p>0 &ndash; 2500, 5500 &ndash; 8000</p>
</td>
<td style={styles.cell}>
<p>0.1551</p>
</td>
</tr>
</tbody>
<tbody>
<tr>
<td style={styles.cell}>
<p><strong>Monoculture </strong></p>
</td>
<td style={styles.cell}>
<p><strong>Function </strong></p>
</td>
<td style={styles.cell}>
<p><strong>Range (m) </strong></p>
</td>
<td style={styles.cell}>
<p><strong>Weight </strong></p>
</td>
</tr>
</tbody>
<tbody>
<tr>
<td style={styles.cell}>
<p>Road</p>
</td>
<td style={styles.cell}>
<p>J-shape Decreasing</p>
</td>
<td style={styles.cell}>
<p>100&ndash;25000</p>
</td>
<td style={styles.cell}>
<p>0.3239</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Slope (%)</p>
</td>
<td style={styles.cell}>
<p>Linear Decreasing</p>
</td>
<td style={styles.cell}>
<p>1&ndash;55</p>
</td>
<td style={styles.cell}>
<p>Constraint</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Industry</p>
</td>
<td style={styles.cell}>
<p>Symmetric</p>
</td>
<td style={styles.cell}>
<p>0 &ndash; 10000, 75000&ndash;85000</p>
</td>
<td style={styles.cell}>
<p>0.1201</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Education</p>
</td>
<td style={styles.cell}>
<p>Symmetric</p>
</td>
<td style={styles.cell}>
<p>0 &ndash; 6000, 20000 &ndash; 35000</p>
</td>
<td style={styles.cell}>
<p>0.1813</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>City center</p>
</td>
<td style={styles.cell}>
<p>Linear Increasing</p>
</td>
<td style={styles.cell}>
<p>0 &ndash; 10000</p>
</td>
<td style={styles.cell}>
<p>0.0568</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Socio-culture</p>
</td>
<td style={styles.cell}>
<p>Symmetric</p>
</td>
<td style={styles.cell}>
<p>0 &ndash; 10000, 30000&ndash;50000</p>
</td>
<td style={styles.cell}>
<p>0.0826</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Bus &amp; Railway Station</p>
</td>
<td style={styles.cell}>
<p>Symmetric</p>
</td>
<td style={styles.cell}>
<p>0 &ndash; 20000, 45000&ndash;65000</p>
</td>
<td style={styles.cell}>
<p>0.2353</p>
</td>
</tr>
</tbody>
<tbody>
<tr>
<td style={styles.cell}>
<p><strong>Agriculture </strong></p>
</td>
<td style={styles.cell}>
<p><strong>Function </strong></p>
</td>
<td style={styles.cell}>
<p><strong>Range (m) </strong></p>
</td>
<td style={styles.cell}>
<p><strong>Weight </strong></p>
</td>
</tr>
</tbody>
<tbody>
<tr>
<td style={styles.cell}>
<p>Road</p>
</td>
<td style={styles.cell}>
<p>Linear Decreasing</p>
</td>
<td style={styles.cell}>
<p>100&ndash;5500</p>
</td>
<td style={styles.cell}>
<p>0.3367</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Slope (%)</p>
</td>
<td style={styles.cell}>
<p>Linear Decreasing</p>
</td>
<td style={styles.cell}>
<p>1&ndash;10</p>
</td>
<td style={styles.cell}>
<p>Constraint</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Industry</p>
</td>
<td style={styles.cell}>
<p>Symmetric</p>
</td>
<td style={styles.cell}>
<p>0 &ndash; 5000, 17000&ndash;22000</p>
</td>
<td style={styles.cell}>
<p>0.1807</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Education</p>
</td>
<td style={styles.cell}>
<p>Symmetric</p>
</td>
<td style={styles.cell}>
<p>0 &ndash; 1500, 3000&ndash;8000</p>
</td>
<td style={styles.cell}>
<p>0.0897</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>City center</p>
</td>
<td style={styles.cell}>
<p>Symmetric</p>
</td>
<td style={styles.cell}>
<p>0 &ndash; 5000, 17000 &ndash; 25000</p>
</td>
<td style={styles.cell}>
<p>0.0305</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Socio-culture</p>
</td>
<td style={styles.cell}>
<p>Symmetric</p>
</td>
<td style={styles.cell}>
<p>0 &ndash; 2000, 6000&ndash;12000</p>
</td>
<td style={styles.cell}>
<p>0.0716</p>
</td>
</tr>
<tr>
<td style={styles.cell}>
<p>Bus &amp; Railway Station</p>
</td>
<td style={styles.cell}>
<p>Symmetric</p>
</td>
<td style={styles.cell}>
<p>0 &ndash; 2500, 8000&ndash;24000</p>
</td>
<td style={styles.cell}>
<p>0.2908</p>
</td>
</tr>
</tbody>
</table>
</center>
<p style={{textAlign:"center"}}><img width={600} height={400} src="images/fig10.png"/></p>
<p style={{textAlign:"center"}}><strong>Figure 10</strong> Projected LU of Gadag.</p>
<p><em><strong>3.3 Prioritization of Ecologically Susceptible Zones (ESZ) at Disaggregated Levels </strong></em></p>
<p>Prioritization of ESZs at disaggregated levels (grids) was achieved by integrating location-specific land, ecology, bio-geo-climatic, energy, and social variables. Weights were assigned to these variables at grid levels based on the conditions assessed through field investigations supplemented with literature review. Figure 11 depicts conditions of the forest and interior forest cover in the grids with their relative weights (based on the spatial extent and ecosystem conditions). This highlighted that the forest cover and the interior forest are intact and dense in the grids corresponding to the Kappata Gudda forest range and Gajendragad region. Figure 12 depicts forest biomass ranging less than 300 Gg and the corresponding weight.</p>
<p style={{textAlign:"center"}}><img width={500} height={500} src="images/fig11.png"/></p>
<p style={{textAlign:"center"}}><strong>Figure 11</strong> Percentage of forest cover, interior forest cover, and the corresponding weights.</p>
<p style={{textAlign:"center"}}><img width={600} height={400} src="images/fig12.png"/></p>
<p style={{textAlign:"center"}}><strong>Figure 12</strong> Biomass of the district and the corresponding weight.</p>
<p>The flora and fauna details (Figure 13) were compiled from the field and published literature [15, 23], and weights were assigned as per the occurrence of species based on their conservation status. The district has 435 species of flora under 106 families with vulnerable species such as <em>Chloroxylon swietenia, Santalum album,</em> and very rare species such as <em>Ehretia laevis.</em> The district has good faunal diversity with 23 mammal, 7 reptile, 338 bird, and 16 fish species with critically endangered (CR) species such as <em>Ardeotis nigriceps, Gyps bengalensis, Gyps indicus, Sarcogyps calvus</em>, vulnerable (VU) species such as <em>Aquila rapax, Cervus unicolor, Ciconia episcopus, Clanga clanga, Clanga hastata, Gallinago nemoricola, Leptoptilos javanicus, Semnopithecus hypoleucos</em>, endangered (EN) species such <em>as Aquila nipalensis, Coun alpinus, Neophron percnopterus, Sterna acuticauda</em> and the near threatened (NT) species like <em>Anhinga melanogaster, Anthracoceros coronatus, Antilope cervicapra, Aythya nyroca, Circus macrourus, Esacus recurvirostris, Falco jugger, Haliaeetus ichthyaetus, Limosa limosa, Mycteria leucocephala, Oreochromis mossambica, Pelecanus philippensis, Phylloscopus tytleri, Sterna auranta, Threskiornis melanocephalus, </em>and<em> Sypheotides indicus</em>. The water availability of the streams across the district was assessed, and the weight was assigned based on the duration of flow (Figure 14). Streams are perennial only in the catchments dominated by forest cover.</p>
<p style={{textAlign:"center"}}><img style={{mixBlendMode:"multiply"}} width={800} height={300} src="images/fig13.png"/></p>
<p><strong>Figure 13</strong> Floral and faunal distribution, and the corresponding weights.</p>
<p style={{textAlign:"center"}}><img style={{mixBlendMode:"multiply"}} width={600} height={400} src="images/fig14.png"/></p>
<p style={{textAlign:"center"}}><strong>Figure 14</strong> Streamflow and the corresponding weights.</p>
<p>Figure 15, Figure 16, and Figure 17 depict the variability of the selected geo-climatic parameters such as elevation, rainfall, slope, soil, and lithology. The soil type was clayey loamy around Gadag taluk and sandy skeletal in the southern rocky outcrops in the north of the district. The weights were assigned based on the water holding capacity of the soil. The slope was approximately 15% across the district, whereas it was greater than 15% in forested areas. The very gently sloping lands covered an area of 362,045 ha (78%), followed by gently sloping lands covering 66,371 ha (14%), and nearly level lands covering an area of 35,964 ha (8%). Gadag has good renewable energy potential across the district (Figure 18). The central government has therefore proposed the development of ultra-mega renewable energy power parks in the district of Gadag.</p>
<p style={{textAlign:"center"}}><img style={{mixBlendMode:"multiply"}} width={600} height={400} src="images/fig15.png"/></p>
<p style={{textAlign:"center"}}><strong>Figure 15 </strong>Elevation and rainfall, with their corresponding weights.</p>
<p style={{textAlign:"center"}}><img style={{mixBlendMode:"multiply"}} width={600} height={400} src="images/fig16.png"/></p>
<p style={{textAlign:"center"}}><strong>Figure 16 </strong>Slope in %, agro-climatic zones, and their corresponding weights.</p>
<p style={{textAlign:"center"}}><img style={{mixBlendMode:"multiply"}} width={600} height={400} src="images/fig17.png"/></p>
<p style={{textAlign:"center"}}><strong>Figure 17 </strong>Soil and lithology details for Gadag region, and their corresponding weights.</p>
<p style={{textAlign:"center"}}><img style={{mixBlendMode:"multiply"}} width={600} height={400} src="images/fig18.png"/></p>
<p style={{textAlign:"center"}}><strong>Figure 18</strong> Energy prospects of Gadag and their corresponding weights.</p>
<p>Gadag ranks 26th in terms of population, with a population of 1,064,570, comprising 537,147 males and 527,423 females (2011 Census). As per the 2011 census, the rural and urban population of the district is 685,261 and 379,309, respectively. The population density was evaluated across the grid for the year 2011, which depicts that the majority of the district has a density of 100&ndash;250 persons per hectare. The population density was revealed to be high in the grids of Gadag city with 250&ndash;500 persons per hectare, while the rest of the grids have a range of 100&ndash;250 persons per hectare (Figure 19). The livestock density at the grid level is a social factor that provides alternative income for the rural population. The total cattle and buffalo population in the district is 203,644, where the population of cattle is 142,655 (70.9%), and that of buffalos is 60,989 (29.1%). The grids of the Ron taluk possessed the highest livestock density, followed by Gadag.</p>
<p style={{textAlign:"center"}}><img style={{mixBlendMode:"multiply"}} width={600} height={400} src="images/fig19.png"/></p>
<p style={{textAlign:"center"}}><strong>Figure 19</strong> Population and livestock densities, and their corresponding weights.</p>
<p>The delineation of ESZs was conducted based on the regional characteristics and the various sensitivity levels described by the data considering distinct themes. The bio-geo-climatic, ecological, and social factors were aggregated, and the grids were grouped into four categories based on the frequency distribution of aggregate scores: ESZ1 (for grids with &gt; &micro; &plusmn;2&alpha; weights, where &micro;: average, &alpha;: standard deviation), ESZ2 (for grids with weights between &micro; &plusmn;2&alpha; and &micro; &plusmn;&alpha;), ESZ3 (grids with weights between &micro; &plusmn;&alpha; and &micro;) and ESZ4 (grids with weights &lt; &micro;). ESZ1 and ESZ2 are highly susceptible zones where any alteration to the ecological integrity is not permitted. These zones fall in the Kappata Gudda range Naragund and Gajendragad and should be devoid of large-scale development projects such as mining. ESZ3 is the region of moderate sensitivity where developmental activities may be allowed with stringent environmental norms through environmental impact assessments (EIA) and environmental management plans (EMP) to mitigate the impacts. Here, unauthorized land conversion will be regulated while permitting location-specific small-scale industries like the agro-based industries, garments industries, information technology (IT), etc., which would boost the rural economy. The rural youth and the women&rsquo;s self-help groups should therefore be provided incentives for setting up new agro-processing industries based on locally available natural resources. It was found that 9 grids (16% spatial extent) of the Gadag district fell under ESZ1, 31 grids (54% spatial extent) under ESZ2, 13 grids (23%) under ESZ3, and the rest under 4 grids (7%) representing ESZ4 (Figure 20). Village-wise ESZ demarcation showed that 36 villages fell under ESZ1, 201 villages under ESZ2, 74 villages underESZ3, and the rest 41 villages fell under ESZ4.</p>
<p style={{textAlign:"center"}}><img width={600} height={400} src="images/fig20.png"/></p>
<p style={{textAlign:"center"}}><strong>Figure 20 </strong>Grid and village-wise ESZ categories in Gadag.</p>
<p>ESZ4 is suitable for developmental activities. The assessment of the spatial extent and visualization of likely changes in the ecosystem shows that urban growth has occurred around the Gajendragad town of the Ron taluk. This study highlights the district&rsquo;s potential of setting up environmentally friendly or less-polluting industries, creating green jobs, and providing an opportunity to transition to a low carbon economy. This entails maintaining ecological integrity by protecting ESZ1 and ESZ2 to sustain water and other natural resources. The regulatory authorities should focus on investments in renewable technologies as an emerging economy in the context of low-carbon growth, including sustainable development. Overall, the state of Karnataka has the potential to create green jobs in the sectors of renewable energy, with 26,000 jobs in the wind energy sector, 14,000 jobs in the biomass-based energy sector, and 833,000 jobs in the solar energy sector [36]. Gadag district is the ideal location for aiming to Decentralized energy development, which reduce the migration problem and aid in socio-economic and environmental welfare gains. Monoculture plantations should be discouraged, and existing exotic plantations should be replaced with native species. Location-specific bio resource-based industries would enhance job opportunities and also the optimal utilization of resources. The activities should be regulated and should be subject to social audits. Those development projects should be adopted which will have the least environmental impact by involving all the stakeholders, including local community members, in decision making and environmental monitoring. Controlled activities should be permitted based on their socio-economic importance. Appropriate conservation and management measures should restrict activities like reclaiming wetlands, converting areas under natural forests, and activities leading to alien invasive species.</p>
<p><strong>4. Discussion</strong></p>
<p><em><strong>4.1 Management of ESZs</strong></em></p>
<p>The management of ESZs entails the protection of natural resources for improving the quality of life for both the present and future generations (stewardship or sustainability) through effective and prudent planning. This includes land use planning, management of water and other resources, and biodiversity conservation to protect natural landscapes and livelihoods. Preventing ESZ from further degradation will support the local communities through improved health and productivity. The management recommendations for the ESZ also focus on permissible activities by emphasizing the future sustainability of agriculture, tourism, fisheries, and forestry. There is a need to address unregulated resource use, unplanned urbanization, and other developmental activities to sustain the livelihoods of local people. ESZ4 and ESZ3 act as &ldquo;shock absorbers&rdquo;. Regulated activities in these regions may therefore enrich the ESZ1 and ESZ2 areas. They also act as a transition zone from areas of high protection to areas involving lesser protection. The policy measures required to sustain natural resources in the Gadag district are provided below:</p>
<ul>
<li>
<p>ESZ1 represents the zone requiring the highest conservation, with stringent norms to prevent further degradation. ESZ2 may be converted to ESZ1 if provided with strict regulations and with the improvement of forests and their environs by increased protection. A small change in ESZ2 will have significant adverse effects on ESZ1.</p>
</li>
<li>
<p>No new major/expansion of roads or railway lines would be allowed in the ecologically susceptible ESZ1. The expansion, if crucial, should be subjected to an EIA (environmental impact assessment) with strict monitoring based on social audits.</p>
</li>
<li>
<p>The Forest Rights Act, 2006 would need to be implemented in its true spirit by ensuring genuine stakeholders are not deprived of their rights</p>
</li>
<li>
<p>Monoculture plantations of exotic species should be regulated in the ESZs, and existing species should be replaced with endemic species.</p>
</li>
<li>
<p>Monoculture plantations of exotic species should be restricted in the plantations within ESZ1.</p>
</li>
<li>
<p>Decentralized energy should be promoted through incentives for harvesting decentralized renewable energy sources (solar, wind, bioresources).</p>
</li>
<li>
<p>Local bio resource-based industries should be promoted with strict regulations, subject to social audits.</p>
</li>
<li>
<p>Development projects with the most negligible environmental impact should be adopted by involving local community members in decision-making and environmental monitoring.</p>
</li>
<li>
<p>The tourism master plan should be as per the guidelines and regulations of the MoEFCC, Government of India (after considering social and environmental costs). Restrictions should be imposed on the construction of large hotels or resorts and new tourism establishments in ESZ1.</p>
</li>
<li>
<p>Controlled activities should be permitted based on socio-economic importance. Activities that deprive wetlands and natural forests and introduce alien invasive species should not be permitted.</p>
</li>
</ul>
<p>The activities (sector-wise) that should be allowed and regulated across various ESZ are as follows:</p>
<ol>
<li>
<p>Energy: Solar (rooftop) energy may be permitted in all zones and wind and bioenergy in all zones except ESZ1.</p>
</li>
<li>
<p>Forests: There should be strict regulations with LU changes (forest to other land uses), restrictions on monoculture plantations, permission to collect NTFP, and forest management by involving all stakeholders through VFCs (Village Forest Committees) in all zones. The extraction of medicinal plants may be permitted on a sustainable basis in ESZ3 and ESZ4. Grid-based mapping aids in identifying the spatial distribution [37] at disaggregated levels of biologically distinct, ecologically valuable, and potential habitats at higher risk [38]. This should be safeguarded under stringent regulations. <span>The conservation and enrichment of the existing biodiversity of the region may be successfully achieved through ecological restoration approaches [39]. The degraded patches in the Kappata Gudda forest region and partly degraded habitats within the district should be enriched with the reforestation of native species, which will aid in habitat restoration, assisted establishment, or assisted colonization of suitable species. Regulating unauthorized LU changes and a complete ban on mining in the Kappata Gudda region will aid decision-makers and forest managers in recovering the land and restoring forest habitat. This also helps understand the risk of fragmentation and prevents decolonization.</span> <span>The protected forest lands would thus act as regeneration blocks and aid in conservation. Monitoring vegetation in such blocks, preferably by local volunteers, would enhance environmental awareness among the local communities.</span></p>
</li>
<li>
<p>Agriculture: Agroforestry, organic farming, and animal husbandry may be practiced in all the zones, with a complete ban on genetically modified crops.</p>
</li>
<li>
<p>Horticulture: The use of hazardous endosulfan should be banned in all zones, and the use of nitrogen (N) and phosphorous (P) should be prohibited. The use of N and P fertilizers, as well as pesticides, may only be permitted in ESZ4, provided the quantity is applied only after the assessment of soil quality. Crops such as watermelon, muskmelon, and ginger cultivation may be practiced only in ESZ3 and ESZ4.</p>
</li>
<li>
<p>Industries (large scale): Agro-processing industries may be permitted in all zones, while green (non-polluting) industries, information technology (IT), and garment industries may be permitted in ESZ3 and ESZ4. The establishment of new industries may be permitted in ESZ4 (allowed only after critical review by local stakeholders and experts). Red category (polluting) industries should be banned in all zones.</p>
</li>
<li>
<p>Industries (small scale): Domestic industries (home-based industries such as for papad, mango processing, milk products and processing, dry fruits and spices, fruit processing, beekeeping and bee nurseries, vegetable dyes, fruits and vegetable preservation, medicinal plants cultivation and processing) may be permitted in all zones. Industries such as coir industries, Pongamia plantations for biofuel (in private lands), biopesticides manufacturing, poultry farms and powdered eggs, aromatic plants and essential oil distillation, flower harvesting industries, and garment industries may be permitted in ESZ2, ESZ3, and ESZ4.</p>
</li>
<li>
<p>Tourism: Promotion of activities such as organic villages and homestays, VFC managed tourism, arts, handicrafts, museum, and trade centers may be permitted in all zones, while ecotourism may be promoted in ESZ2, ESZ3, and ESZ4.</p>
</li>
<li>
<p>Mining and mineral extraction: Sand extraction (on a sustainable basis to meet the local demand with a ban on exporting) may be permitted in ESZ3 and ESZ4, while the extraction of quartz, limestone, etc., may be permitted in ESZ4. Large-scale extraction of iron ore, manganese, and bauxite should be banned in ESZ1 and ESZ2.</p>
</li>
<li>
<p>Waste disposal: Hazardous waste processing units should be banned in ESZ1, ESZ2, and ESZ3. Solid waste disposal, liquid waste discharge, and recycling and waste processing units may only be permitted in ESZ4.</p>
</li>
<li>
<p>Transportation: Linear projects (roads and expressways), railway and freight corridors, and the up-gradation of existing infrastructure may be permitted in ESZ3 and ESZ4.</p>
</li>
</ol>
</li>
</ol></li>
</ol>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default RADPage;
